<template lang="pug">
#modal-cancelamento-operacao
    el-dialog(
        title='Cancelamento de operação',
        width='610px',
        :visible='show',
        @close='closeDialog()'
    )
        h4.mb-4 Atenção, o cancelamento da operação é uma ação irreversível. Deseja continuar?
        p
            b Nome da operação:
            |
            | {{ operacao.nome }}

        el-form(label-position='top', size='small')
            .row
                .col-12
                    el-form-item
                        template(slot='label')
                            span Justificativa

                        el-input(
                            v-model='justificativa',
                            :maxlength='255',
                            placeholder='Justificativa',
                            type='textarea',
                            resize='none',
                            :rows='2'
                        )
        .buttons.center-align
            el-button(size='mini', @click='closeDialog()')
                | Fechar
            el-button(type='primary', size='mini', @click='cancelarOperacao')
                | Confirmar
</template>

<script>
import StatusOperacao from '@/constants/StatusOperacao.js';
import OperacaoService from '@/services/OperacaoService.js';

export default {
    name: 'ModalCancelamentoOperacao',

    emits: ['cancelarOperacao'],

    props: {
        operacao: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            justificativa: null
        };
    },

    methods: {
        closeDialog() {
            this.justificativa = null;
            this.$emit('update:show', false);
        },

        async cancelarOperacao() {
            if (this.justificativa == null || this.justificativa.length === 0) {
                this.$notify.error({
                    message: 'Preencha a justificativa.'
                });
                return;
            }

            const cancelamentoOperacao = {
                idOperacao: this.operacao.id,
                idStatusOperacao: StatusOperacao.CANCELADO,
                parecer: this.justificativa
            };

            await OperacaoService.atualizarStatus(cancelamentoOperacao)
                .then(() => {
                    this.$notify.success({
                        message: 'Operação cancelada com sucesso!'
                    });
                    this.$emit('cancelarOperacao');
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Não foi possivel realizar o cancelamento.'
                    });
                })
                .finally(() => this.closeDialog());
        }
    }
};
</script>

<style lang="scss">
#modal-cancelamento-operacao {
    .center-align {
        text-align: center;
        justify-content: space-between;
        display: flex;
    }

    h4.mb-4 {
        word-break: break-word;
        font-size: 14px !important;
    }

    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: -20px 0 20px 0;
    }

    .link {
        margin-left: 20px;
        cursor: pointer;

        i {
            display: inline-flex;
            vertical-align: bottom;
            font-style: normal;
            font-size: 13px;
        }
    }

    .margin-p {
        margin-bottom: 0;
    }
}
</style>
